import type { SelectProps } from '@chakra-ui/react'
import { forwardRef, Select } from '@chakra-ui/react'

import { useCountries } from '../hooks'

interface CountrySelectProps extends SelectProps {
  hiddenIds?: number[]
}

export const CountrySelect = forwardRef(({ hiddenIds, ...props }: CountrySelectProps, ref: any) => {
  const { data: countries, isLoading: countriesIsLoading, isFetching: countriesIsFetching } = useCountries()

  return (
    <>
      {countries && countries?.length > 0 &&
        <Select {...props} ref={ref}>
          <option disabled value={undefined}>
            Vyberte státní občanství
          </option>
          {countries?.filter(x => !hiddenIds || !hiddenIds.includes(x.id)).map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </Select>
      }
    </>
  )
})
